import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'string-list-editor',
    templateUrl: './string-list-editor.component.html',
    styleUrls: ['./string-list-editor.component.scss'],
    standalone: false,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => StringListEditorComponent),
        multi: true
    }]
})
export class StringListEditorComponent implements ControlValueAccessor {

    _Utils = Utils;

    @Input()
    ngModel: string[];
    @Output()
    ngModelChange = new EventEmitter<string[]>();

    @Input()
    addTitle = "";

    @ViewChildren('itemDivs') itemDivs: QueryList<ElementRef>;

    @Input() value: string[] = [];
    onChange = (_: any): any => { };
    onTouched = (): any => { };

    writeValue(v: string[]): void { this.value = v || []; }
    registerOnChange(fn: any): void { this.onChange = fn; }
    registerOnTouched(fn: any): void { this.onTouched = fn; }

    dragIndex: number;
    dropTargetIndex: number;
    dragHandleClicked = false;
    
    removeItem(index: number): void {
        this.ngModel.splice(index, 1);
        this.emitChange();
    }

    addItem(): void {
        this.ngModel.push("");
        this.emitChange();
        GuiUtils.angularTimer(() => {
            if (this.itemDivs != null && this.itemDivs.length > 0) {
                let ne = this.itemDivs.get(this.itemDivs.length - 1).nativeElement.querySelector("input");
                ne.focus();
            }
        });
    }

    trackByFn(index, _): void {
        return index;
    }

    keyPressed(event: any): void {
        if (event.key == "Enter") {
            this.addItem();
        }
    }

    emitChange(): void {
        this.ngModelChange.emit(this.ngModel);
    }

    onDragStart(event: DragEvent, index: number): void {
        if (!this.dragHandleClicked) {
            event.preventDefault();
            return;
        }

        this.dragIndex = index;
        event.dataTransfer.setData('text/plain', index.toString());
        event.dataTransfer.effectAllowed = 'move';
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }

    onDragEnter(event: DragEvent, index: number): void {
        this.dropTargetIndex = index;
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();

        if (this.dragIndex == null || this.dropTargetIndex == null || this.dragIndex === this.dropTargetIndex) {
            this.dragIndex = null;
            this.dropTargetIndex = null;
            return;
        }

        const moved = this.ngModel.splice(this.dragIndex, 1)[0];
        this.ngModel.splice(this.dropTargetIndex, 0, moved);
        this.emitChange();

        this.dragIndex = null;
        this.dropTargetIndex = null;
    }

    onDragEnd(_: DragEvent): void {
        this.dragIndex = null;
        this.dropTargetIndex = null;
    }

}
